<template>
  <div ref="listOfVns" :class="[classHowManyVns, { 'monitor-mode': monitorMode }]">
    <div class="hexagon-grid-container">
      <vnsHexagonSubtitle
          :title="$t('components.subtitle.vns_novo')"
          :description="$t('components.subtitle.vns_novo_desc')"
          :contador="this.legendCountPrimary"
          :hexagon-class="'hexagon-primary'"
          :hexagon-row-class="'row-primary'"
      />
      <vnsHexagonSubtitle
          :title="$t('components.subtitle.vns_ativo')"
          :description="$t('components.subtitle.vns_ativo_desc')"
          :contador="this.legendCountSuccess"
          :hexagon-class="'hexagon-success'"
          :hexagon-row-class="'row-success'"
      />
      <vnsHexagonSubtitle
          :title="$t('components.subtitle.vns_desconectado')"
          :description="$t('components.subtitle.vns_desconectado_desc')"
          :contador="this.legendCountWarning"
          :hexagon-class="'hexagon-warning'"
          :hexagon-row-class="'row-warning'"
      />
      <vnsHexagonSubtitle
          :title="$t('components.subtitle.vns_offline')"
          :description="$t('components.subtitle.vns_offline_desc')"
          :contador="this.legendCountDanger"
          :hexagon-class="'hexagon-danger'"
          :hexagon-row-class="'row-danger'"
      />
      <vnsHexagonSubtitle
          :title="$t('components.subtitle.vns_em_analise')"
          :description="$t('components.subtitle.vns_em_analise_desc')"
          :contador="this.legendCountSecondary"
          :hexagon-class="'hexagon-secondary'"
          :hexagon-row-class="'row-secondary'"
      />
    </div>
  </div>
</template>

<script>
import vnsHexagonSubtitle from "@/pages/vns/components/vnsHexagonSubtitle";

export default {
  name: "vnsHexagonListSubtitle",
  components: {
    vnsHexagonSubtitle
  },
  props: {
    monitorMode: {
      type: Boolean,
      default: false
    },
    legendCountPrimary: {
      type: Number,
      default: 0
    },
    legendCountSuccess: {
      type: Number,
      default: 0
    },
    legendCountWarning: {
      type: Number,
      default: 0
    },
    legendCountDanger: {
      type: Number,
      default: 0
    },
    legendCountSecondary: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      vnsPerLine: 5
    }
  },
  computed: {
    classHowManyVns() {
      switch (this.vnsPerLine) {
        case 2:
          return 'two-vns-per-line'
          break;
        case 3:
          return 'three-vns-per-line'
          break;
        case 4:
          return 'four-vns-per-line'
          break;
        case 5:
          return 'five-vns-per-line'
          break;
        default:
          return 'five-vns-per-line'
          break;
      }
    }
  },
  methods: {
    getAvailableSize() {
      if (this.monitorMode) {
        this.vnsPerLine = 5
        return
      }
      const width = this.$refs.listOfVns.clientWidth
      switch (true) {
        case (width >= 720):
          this.vnsPerLine = 5
          break;
        case (width < 720 && width >= 576):
          this.vnsPerLine = 4
          break;
        case (width < 576 && width >= 432):
          this.vnsPerLine = 3
          break;
        case (width < 431):
          this.vnsPerLine = 2
          break;
          this.$forceUpdate()
      }
    }
  },
  mounted() {
    // window.addEventListener("resize", this.getAvailableSize)
    this.timer = setInterval(() => {
      this.getAvailableSize()
    }, 1000)
  },
  updated() {
    this.getAvailableSize()
  },
  beforeDestroy() {
    // window.removeEventListener("resize", this.getAvailableSize)
    clearInterval(this.timer)
  }
}
</script>

<style lang="scss" scoped>

$primary: #4e73df;
$secondary: #858796;
$success: #1cc88a;
$warning: #f6c23e;
$danger: #e74a3b;

/* Outer Hexagon */
.hexagon-grid-container {
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  list-style: none;
  margin-left: auto !important;
  margin-right: auto !important;
  margin-bottom: 100px;
}

/* Media queries */
.five-vns-per-line {
  .hexagon-grid-container {
    width: 720px;
  }

  .hexagon:nth-child(9n+6) {
    margin-left: 74px;
  }
}

.four-vns-per-line {
  .hexagon-grid-container {
    width: 576px;
  }

  .hexagon:nth-child(7n+5) {
    margin-left: 74px;
  }
}

.three-vns-per-line {
  .hexagon-grid-container {
    width: 432px;
  }

  .hexagon:nth-child(5n+4) {
    margin-left: 74px;
  }
}

.two-vns-per-line {
  .hexagon-grid-container {
    width: 320px;
  }

  .hexagon:nth-child(3n+3) {
    margin-left: 74px;
  }
}

/* Hexagon Color Coding */
.hexagon-success {
  background-color: $success;

  &:before {
    border-bottom: 40.41px solid $success;
  }

  &:after {
    border-top: 40.41px solid $success;
  }
}

.hexagon-warning {
  background-color: $warning;

  &:before {
    border-bottom: 40.41px solid $warning;
  }

  &:after {
    border-top: 40.41px solid $warning;
  }
}

.hexagon-danger {
  background-color: $danger;

  &:before {
    border-bottom: 40.41px solid $danger;
  }

  &:after {
    border-top: 40.41px solid $danger;
  }
}

.hexagon-primary {
  background-color: $primary;

  &:before {
    border-bottom: 40.41px solid $primary;
  }

  &:after {
    border-top: 40.41px solid $primary;
  }
}

.hexagon-secondary {
  background-color: $secondary;

  &:before {
    border-bottom: 40.41px solid $secondary;
  }

  &:after {
    border-top: 40.41px solid $secondary;
  }
}

.hexagon-danger,
.hexagon-primary,
.hexagon-success,
.hexagon-warning,
.hexagon-secondary {
  color: white;
}

/* Monitor mode: hexagons scaled to 8/10 */
.monitor-mode {
  .hexagon-grid-container {
    transform: scale(0.8);
    transform-origin: top center;
    margin-bottom: 70px;

    ::v-deep .hexagon-description {
      font-size: 14px;
    }
  }
}

</style>
